import * as THREE from "three";

export const METAL = [
  {
    name: "Black Matt",
    listName: "METAL",
    texture: "./textures/metal/black matt/color_b.jpg",
    roughnessMap: "./textures/metal/black matt/roughness.jpg",
    normalMap: "./textures/metal/black matt/normal.png",
    metalnessMap: "./textures/metal/black matt/metalness.jpg",
    size: [0.1, 0.1, 0.1],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 1,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 7,
    emissive: false,
  },
  {
    name: "Frosted Silver",
    listName: "METAL",
    texture: "./textures/metal/frosted silver/color_c.jpg",
    roughnessMap: "./textures/metal/frosted silver/metalness.jpg",
    normalMap: "./textures/metal/frosted silver/normal.png",
    metalnessMap: "./textures/metal/frosted silver/roughness.jpg",
    size: [0.1, 0.1, 0.1],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 1,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
    emissive: false,
  },
  {
    name: "Polished Silver",
    listName: "METAL",
    texture: "./textures/metal/polished silver/color_b.jpg",
    // roughnessMap: "./textures/metal/polished silver/metalness.jpg",
    normalMap: "./textures/metal/polished silver/normal-side.jpg",
    metalnessMap: "./textures/metal/polished silver/roughness.jpg",
    size: [0.1, 0.1, 0.1],
    offset: [0.0, 0.0],
    roughness: 0.5,
    metalness: 1,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 2,
    emissive: false,
    normalScale: 5,
  },
  {
    name: "Maple",
    listName: "METAL",
    texture: "./textures/metal/Maple/color-b.webp",
    roughnessMap: "./textures/metal/Maple/roughness.webp",
    normalMap: "./textures/metal/Maple/normal.webp",
    //metalnessMap: "./textures/metal/511/roughness.png",
    size: [0.02, 0.75, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 0.5,
  },
  {
    name: "Oak",
    listName: "METAL",
    texture: "./textures/metal/Oak/color.webp",
    roughnessMap: "./textures/metal/Oak/roughness.webp",
    normalMap: "./textures/metal/Oak/normal.webp",
    //metalnessMap: "./textures/metal/511/roughness.png",
    size: [0.02, 0.75, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Dark Wenge",
    listName: "METAL",
    texture: "./textures/metal/Dark Wenge/color_c.webp",
    roughnessMap: "./textures/metal/Dark Wenge/roughness.webp",
    normalMap: "./textures/metal/Dark Wenge/normal.webp",
    //metalnessMap: "./textures/metal/511/roughness.png",
    size: [0.02, 0.75, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
  {
    name: "Dark Grey",
    listName: "METAL",
    texture: "./textures/metal/Dark Grey/color_b.webp",
    roughnessMap: "./textures/metal/Dark Grey/roughness.webp",
    normalMap: "./textures/metal/Dark Grey/normal.webp",
    //metalnessMap: "./textures/metal/511/roughness.png",
    size: [0.02, 0.75, 0.05],
    offset: [0.5, 0.0],
    roughness: 1,
    metalness: 0,
    rotation: 0,
    space: THREE.SRGBColorSpace,
    envMapIntensity: 1,
  },
];

/**
<Radio.Button value="511">Acre</Radio.Button>
<Radio.Button value="514">Oak</Radio.Button>
<Radio.Button value="516">Dark Wenge</Radio.Button>
<Radio.Button value="524">Antiacite</Radio.Button>
 */
